import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import LoadingImage from '../Images/loading.gif';
import ErrorPage from './Errorpage';

const SSBCI = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [redirectUrl, setRedirectUrl] = useState('');
  const [responseData, setResponseData] = useState(null);
  const location = useLocation();
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
  useEffect(() => {
    try {
      window.history.pushState("you are being redirected...", "Redirect", "/redirect");
    } catch (err) {
      if (typeof console !== 'undefined') console.log(err);
    }
    const queryParams = new URLSearchParams(location.search);
    const CaeQMemID = queryParams.get('memqnxtid');
    const SystemId = queryParams.get('SystemId');
    const UserId = queryParams.get('UserId');
    const Module = queryParams.get('module');
    const RoleTypeId = queryParams.get('RoleTypeId');
    
    fetchSSBCIURL(CaeQMemID, SystemId, UserId, Module,RoleTypeId );
  }, [location]);

  const fetchSSBCIURL = async (CaeQMemID, SystemId, UserId, Module,RoleTypeId) => {
    try {
      const response = await axios.get(`${API_URL}/api/SSBCI/GetSSBCIUrl`, {
        params: {
          CaeQMemID: CaeQMemID || '',
          SystemId: SystemId || '',
          UserId: UserId || '',
          Module: Module || 'SSBCI',
          RoleTypeId: RoleTypeId || ''
        }
      });
      setResponseData(response.data);
      setLoading(false);
      if (response.data && response.data.url) {
        setRedirectUrl(response.data.url);
        window.location.href = response.data.url;
      } else {
        setError('ssbci');
      }
    } catch (error) {
      console.error('Error fetching SSBCI URL:', error);
      if (error.response && error.response.data && error.response.data.message) {
        setError(error.response.data.message);
      } else {
        setError('ssbci');
      }
      setLoading(false);
    }
  };
  const formatJSON = (json) => {
    return JSON.stringify(json, null, 2);
  };
  return (
    <div>
      <div>
        <table style={{backgroundColor: 'transparent'}} cellPadding="0" cellSpacing="0" align="center">
          <tbody>
            <tr>
              <td>
                <div style={{width: '99%'}}>
                  <div style={{marginLeft: '49%'}}>
                    {loading && (
                      <>
                        <div style={{float: 'left'}}>
                          <img id="loadinggif" src={LoadingImage} alt="Loading" />
                        </div>
                        <div id="loadingtext" style={{float: 'left'}}>
                          Loading...
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td align="center" style={{fontSize: 'x-large'}}>
                {error && <ErrorPage errorType="ssbci" />}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SSBCI;